import React from 'react';
import ReactDOM from 'react-dom';
import { Alert } from './Alert';

const withAlert = WrappedComponent =>
  class extends React.Component {
    bIsMounted = false;
    constructor(oProps) {
      super(oProps);

      this.state = {
        aAlertMessages: []
      };
    }

    componentWillUnmount() {
      this.bIsMounted = false;
    }

    componentDidMount() {
      this.bIsMounted = true;
      const { location } = this.props;
      this.container = document.querySelector('.MessageHolder');

      if (location && location.state && location.state.aAlertMessages !== undefined) {
        this.setState(oCurrentState => ({
          aAlertMessages: oCurrentState.aAlertMessages.concat(location.state.aAlertMessages)
        }));
      }
    }

    setAlert = (cType, cMsg) => {
      if (this.bIsMounted && cMsg) {
        this.setState({
          aAlertMessages: [{ cType, cMsg }]
        });
        window.scrollTo(0, 0);
      }
    };

    addAlert = (cType, cMsg) => {
      if (cMsg) {
        this.setState(oCurrentState => ({
          aAlertMessages: oCurrentState.aAlertMessages.concat({ cType, cMsg })
        }));
      }
    };

    clearAlert = () => {
      this.setState({
        aAlertMessages: []
      });
    };

    onCloseAlert = cKey => {
      const { aAlertMessages } = this.state;

      this.setState({
        aAlertMessages: aAlertMessages.filter((cValue, cIndex) => cIndex !== cKey)
      });
    };

    render() {
      const { aAlertMessages } = this.state;
      const aAlerts = aAlertMessages.map((oAlert, cKey) => (
        <Alert type={oAlert.cType} isOpen key={cKey} onCloseAlert={() => this.onCloseAlert(cKey)}>
          {typeof oAlert.cMsg === 'string'
            ? oAlert.cMsg
            : oAlert.cMsg.map(cMsg => (
              <p key={Math.random()}>{typeof cMsg === 'string' ? cMsg : JSON.stringify(cMsg)}</p>
            ))}
        </Alert>
      ));

      return (
        <>
          {this.container && aAlertMessages.length > 0 && ReactDOM.createPortal(aAlerts, this.container)}

          <WrappedComponent
            {...this.props}
            addAlert={this.addAlert}
            setAlert={this.setAlert}
            clearAlert={this.clearAlert}
          />
        </>
      );
    }
  };
export default withAlert;
